import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import { LanguageCode, TermsAndConditionsFormValues, TermsAndConditionsHistory } from "../termsAndConditionTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import * as Yup from "yup"
import { TermsAndConditionFormContent } from "./TermsAndConditionFormContent"

type CreateOrEditTermsAndConditionFormProps = Readonly<{
    initialValues?: TermsAndConditionsFormValues | null
    history?: TermsAndConditionsHistory
    version?: number
    onSubmit: (formData: TermsAndConditionsFormValues) => void
}>
type FormikRef = Ref<FormikProps<TermsAndConditionsFormValues>>

export const CreateOrEditTermsAndConditionForm = forwardRef(
    ({ initialValues, history, version, onSubmit }: CreateOrEditTermsAndConditionFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues: TermsAndConditionsFormValues = {
            type: "",
            languageCode: LanguageCode.DA,
            callName: "",
            isActive: true,
            text: "",
        }

        const validationSchema = Yup.object().shape({
            callName: Yup.string().required().label(l10n.getString("terms-and-conditions-error-label-name")),
            type: Yup.string().required().label(l10n.getString("terms-and-conditions-error-label-type")),
            languageCode: Yup.string().required().label(l10n.getString("terms-and-conditions-error-label-language")),
            text: Yup.string().required().label(l10n.getString("terms-and-conditions-error-label-text")),
            isActive: Yup.boolean(),
        })

        function handleSubmit(values: TermsAndConditionsFormValues) {
            onSubmit(values)
        }

        return (
            <Formik<TermsAndConditionsFormValues>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <TermsAndConditionFormContent history={history} version={version} />
                </Form>
            </Formik>
        )
    },
)
